const FastIcon = ({ fill = "none", width = "18", height = "18" }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.56758 9.95992H6.88508V15.3599C6.88508 16.6199 7.56758 16.8749 8.40008 15.9299L14.0776 9.47992C14.7751 8.69242 14.4826 8.03992 13.4251 8.03992H11.1076V2.63992C11.1076 1.37992 10.4251 1.12492 9.59258 2.06992L3.91508 8.51992C3.22508 9.31492 3.51758 9.95992 4.56758 9.95992Z" stroke={fill} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export default FastIcon